import { useState } from 'react';
import { CopyIcon, CopyCheckIcon } from './icons.tsx';
import styles from './EmailDisplay.module.css';

interface Props {
  email: string;
}

export function EmailDisplay({ email }: Props) {
  const [copied, setCopied] = useState(false);

  function handleCopy(e: React.MouseEvent) {
    e.stopPropagation();
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }

  return (
    <span className={styles.wrapper}>
      <span className={styles.value}>{email}</span>
      <button
        type="button"
        className={styles.copyBtn}
        onClick={handleCopy}
        title={copied ? 'Gekopieerd!' : 'Kopieer e-mailadres'}
        aria-label="Kopieer e-mailadres"
      >
        {copied ? <CopyCheckIcon /> : <CopyIcon />}
      </button>
    </span>
  );
}
